import React, { useState } from 'react';

const slides = [
  {
    title: 'Tips for First Trimester',
    image: '/1p.png',
    tips: [
      'Book your first check-up early',
      'Take prenatal vitamins daily',
      'Eat small snacks for nausea',
      'Add iron-rich foods like spinach',
      'Drink plenty of water',
      'Avoid raw sushi & soft cheese',
      'Rest often and listen to your body',
    ],
  },
  {
    title: 'Tips for Second Trimester',
    image: '/2p.png',
    tips: [
      'Attend routine scans',
      'Sleep on your side',
      'Support your back with pillows',
      'Eat high-fiber foods to avoid constipation',
      'Practice gentle stretching',
      'Start pelvic floor exercises',
      'Stay hydrated',
    ],
  },
  {
    title: 'Tips for Third Trimester',
    image: '/3p.png',
    tips: [
      'Track baby movements daily',
      'Discuss birth plan with doctor',
      'Pack your hospital bag early',
      'Rest with feet elevated',
      'Attend birthing classes',
      'Eat protein-rich snacks',
      'Prepare for breastfeeding',
    ],
  },
  {
    title: 'Postpartum Recovery Tips',
    image: '/4p.png',
    tips: [
      'Rest whenever the baby sleeps',
      'Ask for help when needed',
      'Eat nourishing meals',
      'Stay hydrated to support milk supply',
      'Start slow gentle walks',
      'Attend postpartum check-ups',
      'Prioritize mental health',
    ],
  },
];

const PregnancyTipsCarousel = () => {
  const [current, setCurrent] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const nextSlide = () => {
    if (!isTransitioning) {
      setIsTransitioning(true);
      setCurrent((current + 1) % slides.length);
      setTimeout(() => setIsTransitioning(false), 500);
    }
  };

  const prevSlide = () => {
    if (!isTransitioning) {
      setIsTransitioning(true);
      setCurrent((current - 1 + slides.length) % slides.length);
      setTimeout(() => setIsTransitioning(false), 500);
    }
  };

  const { title, image, tips } = slides[current];

  return (
    <div
      className="carousel-container"
      style={{
        width: '550px',
        minHeight: 'auto',
        display: 'flex',
        alignItems: 'flex-start',
        gap: '30px',
        padding: '20px',
        border: '1px solid #eee',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        backgroundColor: '#fff',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          transition: 'transform 0.5s ease-in-out, opacity 0.5s ease-in-out',
          transform: isTransitioning ? 'translateX(-20px)' : 'translateX(0)',
          opacity: isTransitioning ? 0 : 1,
        }}
      >
        <img
          src={image}
          alt={title}
          style={{
            width: 'auto',
            height: '340px',
            borderRadius: '10px',
            objectFit: 'cover',
            transition: 'transform 0.3s ease',
          }}
          onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
          onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
        />
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          textAlign: 'left',
          flexGrow: 1,
          transition: 'transform 0.5s ease-in-out, opacity 0.5s ease-in-out',
          transform: isTransitioning ? 'translateX(20px)' : 'translateX(0)',
          opacity: isTransitioning ? 0 : 1,
        }}
      >
        <div>
          <h4
            style={{
              marginBottom: '5px',
              fontSize: '20px',
              color: '#B85170',
              minHeight: '48px',
              transition: 'color 0.3s ease',
            }}
            onMouseOver={(e) => e.currentTarget.style.color = '#9a3f5a'}
            onMouseOut={(e) => e.currentTarget.style.color = '#B85170'}
          >
            {title}
          </h4>
          <ul
            style={{
              fontSize: '16px',
              color: '#444',
              lineHeight: '1.8',
              listStyleType: 'disc',
              paddingLeft: '20px',
              margin: 0,
              maxHeight: '230px',
              overflowY: 'auto',
            }}
          >
            {tips.map((tip, idx) => (
              <li 
                key={idx}
                style={{
                  transition: 'transform 0.2s ease',
                  cursor: 'pointer',
                }}
                onMouseOver={(e) => e.currentTarget.style.transform = 'translateX(5px)'}
                onMouseOut={(e) => e.currentTarget.style.transform = 'translateX(0)'}
              >
                {tip}
              </li>
            ))}
          </ul>
        </div>
        <div style={{ marginTop: '15px' }}>
          <button 
            onClick={prevSlide} 
            style={{ 
              marginRight: '10px', 
              padding: '8px 16px',
              border: 'none',
              borderRadius: '4px',
              backgroundColor: '#B85170',
              color: 'white',
              cursor: 'pointer',
              transition: 'background-color 0.3s ease, transform 0.2s ease',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#9a3f5a';
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = '#B85170';
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            ←
          </button>
          <button 
            onClick={nextSlide} 
            style={{ 
              padding: '8px 16px',
              border: 'none',
              borderRadius: '4px',
              backgroundColor: '#B85170',
              color: 'white',
              cursor: 'pointer',
              transition: 'background-color 0.3s ease, transform 0.2s ease',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#9a3f5a';
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = '#B85170';
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            →
          </button>
        </div>
      </div>
    </div>
  );
};

export default PregnancyTipsCarousel;